import React from "react"

import background from "../assets/images/wave-bg.svg"
import styles from "../styles/footer.module.css"

export default function Footer({ showPrivacy }) {
  const d = new Date()
  const year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d)
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <a className={styles.text} href="mailto:codaxelabs@gmail.com">Contact</a>
        <p className={styles.text} onClick={showPrivacy}>
          Privacy policy
        </p>
      </div>
      <p className={styles.copy}>&copy; {year} Codaxe Labs</p>
      <img className={styles.background} src={background} alt="Logo" />
    </div>
  )
}
